import { createStore, sample } from 'effector'
import { not } from 'patronum'

import { $portalProfile, persistProfileData } from '@/entities/profile/portal'
import { analytics } from '@/shared/lib/analytics'

// flag that indicates whether registration event was sent
const $registrationSent = createStore(false).on(analytics.registration, () => true)

// wait for `showGuiLetter` story step and extract supportId from profile
const stepShowGuiLetter = sample({
    clock: analytics.storyStep,
    source: $portalProfile,
    filter: (profile, step) => step.label === 'showGuiLetter' && profile !== null,
    fn: (profile) => ({ supportId: profile!.supportId }),
})

// send registration event when `showGuiLetter` story step is reached (effective registration)
sample({
    clock: stepShowGuiLetter,
    filter: not($registrationSent),
    target: analytics.registration,
})

// persist registrationSent flag in localStorage to prevent sending registration event twice
persistProfileData({
    store: $registrationSent,
    key: 'analytics.registration.sent',
})
